import { useEffect } from "react";
import { PaymentHistoryModalHeader } from "./PaymentHistoryModalHeader";
import { PaymentHistoryModalFormWrapper } from "./PaymentHistoryModalFormWrapper";

const PaymentHistoryModal = ({
  setOpenPaymentHistoryModal,
  selectedBookingId,
  setSelectedBookingId
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-650px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <PaymentHistoryModalHeader
              selectedBookingId={selectedBookingId}
              setSelectedBookingId={setSelectedBookingId}
              setOpenPaymentHistoryModal={setOpenPaymentHistoryModal}
            />
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <PaymentHistoryModalFormWrapper
                 selectedBookingId={selectedBookingId}
                 setSelectedBookingId={setSelectedBookingId}
                 setOpenPaymentHistoryModal={setOpenPaymentHistoryModal}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export { PaymentHistoryModal };
